import axios from "axios";
const endPoint = "SKU";
const getEndPoint = `${endPoint}/getAllSetting`;
const updateEndPoint = `${endPoint}`;
const getCapacitiesEndPoint = `${endPoint}/GetCapacityList`;
export function getAllPowerBICapacityManagement () { return axios.get(getEndPoint) ;}
export function updatePowerBICapacityManagement (data) { return  axios.post(updateEndPoint, data); }
export function GetAllCapacities() { return axios.get(getCapacitiesEndPoint); }